// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__26eDL","productName":"Table_productName__3dpYc"};